import { POST, GET } from './utils';

export const GET_DOCUMENT = ({ documentId, token }) =>
  GET({ url: `esignature/${documentId}/${token}` });

export const UPDATE_DOCUMENT = (data) => POST({ url: 'esignature/update', data });

export const DOWNLOAD_DOCUMENT = ({ documentId, token }) =>
  GET({ url: `esignature/${documentId}/${token}/download` });
